"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApiBuilder = void 0;
var react_1 = require("react");
var usePromiseBuilder_1 = require("./usePromiseBuilder");
function useApiBuilder(callback, dependencies) {
    var memoValue = react_1.useMemo(function () { return callback(); }, dependencies !== null && dependencies !== void 0 ? dependencies : []);
    var resp = usePromiseBuilder_1.usePromiseBuilder(memoValue, dependencies);
    return resp;
}
exports.useApiBuilder = useApiBuilder;
